import React from 'react';

const LoadingScreen = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: '#DA291C', // Vermelho McDonald's
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      margin: 0,
      padding: 0
    }}>
      <style>
        {`
          .arches-path {
            stroke-dasharray: 340;
            stroke-dashoffset: 340;
            animation: 
              drawLogo 1.5s cubic-bezier(0.4, 0, 0.2, 1) forwards, 
              metallicShine 2s infinite 1.5s linear;
          }

          @keyframes drawLogo {
            to { stroke-dashoffset: 0; }
          }

          @keyframes metallicShine {
            0% { filter: drop-shadow(0px 0px 2px rgba(255, 199, 44, 0.3)); }
            50% { filter: drop-shadow(0px 0px 12px rgba(255, 199, 44, 0.9)); }
            100% { filter: drop-shadow(0px 0px 2px rgba(255, 199, 44, 0.3)); }
          }

          .loading-dot {
            width: 10px; 
            height: 10px;
            background-color: #FFC72C;
            border-radius: 50%;
            animation: waveMotion 1.2s infinite ease-in-out;
          }

          .dot-1 { animation-delay: 0s; }
          .dot-2 { animation-delay: 0.15s; }
          .dot-3 { animation-delay: 0.3s; }
          .dot-4 { animation-delay: 0.45s; }

          @keyframes waveMotion {
            0%, 100% { transform: translateY(0); opacity: 0.3; }
            50% { transform: translateY(-8px); opacity: 1; }
          }
        `}
      </style>

      <svg 
        width="160" 
        height="120" 
        viewBox="0 0 120 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <path
          className="arches-path"
          // Coordenadas matematicamente ajustadas para a parábola do McDonald's
          d="M 15 90 C 15 -10, 53 -10, 60 79 C 67 -10, 105 -10, 105 90"
          stroke="#FFC72C" // Dourado McDonald's
          strokeWidth="11"
          strokeLinecap="butt" // Garante o corte reto na base
          strokeLinejoin="miter" // Garante a junção afiada no "V" central
        />
      </svg>

      <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <div className="loading-dot dot-1"></div>
        <div className="loading-dot dot-2"></div>
        <div className="loading-dot dot-3"></div>
        <div className="loading-dot dot-4"></div>
      </div>
    </div>
  );
};

export default LoadingScreen;